
import { Component } from "vue-property-decorator";
import { lectureService } from "@/service/api/LectureService";
import { userService } from "@/service/api/UserService";
import PageDataModel from "@/service/model/common/PageDataModel";
import { UserRegistrationInfoTableConfig } from "@/components/lecture/detail/model/UserRegistrationInfoTableConfig";
import moment, { Moment } from "moment";
import Base from "@/Base";

@Component
export default class UsersLectureEnrollment extends Base {
  private isLoading = false;

  private startedAt: string | null = null;
  private endedAt: string | null = null;

  private userRegistrationInfoTableConfig = UserRegistrationInfoTableConfig;

  private allUserList: PageData<UserDetail> = new PageDataModel<UserDetail>();
  private selectedUserIdList: string[] = [];
  private keyword = "";

  public created(): void {
    this.getUserList(1);
  }

  private getUserList(page: number): void {
    if (this.keyword.split("\n").length >= 100) {
      this.confirm$.open({
        title: "검색 오류",
        content:
          "100개 이상의 연속 조회는 서버에 부하가 많습니다.\n100개씩 검색해 주세요"
      });
      return;
    }

    this.isLoading = true;
    userService
      .retrieveUserList(page, 10, "", "", "ALL", this.keyword)
      .subscribe((userDetailPageData: PageData<UserDetail>) => {
        this.allUserList = userDetailPageData;
        this.isLoading = false;
      });
  }

  private get rowSelection() {
    return {
      selectedRowKeys: this.selectedUserIdList,
      onChange: this.onSelectChange
    };
  }

  private onSelectChange(selectedRowKeys: string[]): void {
    this.selectedUserIdList = selectedRowKeys;
  }

  private onClickRegister(): void {
    this.confirm$.open({
      title: "수강생 등록",
      content: `이 강의에 수강생 ${this.selectedUserIdList.length}명에게 ${this.startedAt} ~ ${this.endedAt} 기간으로 등록하시겠습니까?`,
      confirm: { callback: this.handleRegisterToUsers }
    });
  }

  private handleRegisterToUsers(): void {
    this.isLoading = true;

    const usersDataForEnroll: UsersDataForEnroll = {
      lectureId: parseInt(this.$route.params.id),
      users: this.selectedUserIdList,
      startTime: this.startedAt as string,
      endedTime: this.endedAt as string
    };

    lectureService
      .enrollUsers(usersDataForEnroll)
      .subscribe((isSuccess: boolean) => {
        this.isLoading = false;
        if (isSuccess) {
          this.$message.success("수강생들이 등록되었습니다.");
          this.getUserList(1);
          this.selectedUserIdList = [];
        } else {
          this.openRequestFailAlert();
        }
      });
  }

  private onChangeRangeDate([startedAt, endedAt]: [Moment, Moment]): void {
    if (startedAt) {
      this.startedAt = moment(startedAt).format("YYYY-MM-DD");
      this.endedAt = moment(endedAt).format("YYYY-MM-DD");
    } else {
      this.startedAt = null;
      this.endedAt = null;
    }
  }

  private get isDisableRegisterButton(): boolean {
    return (
      this.selectedUserIdList.length === 0 || !this.startedAt || !this.endedAt
    );
  }
}
